import type { WithActiveBranchId } from '@app/api/shared';
import type { CountryAlpha2, CountryAlpha3 } from '@app/types';

export enum DictionariesEndpoints {
  GetCountries = 'GetCountries',
  GetUsedCountries = 'GetUsedCountries',
  GetUsedCities = 'GetUsedCities',
  GetClientLanguages = 'GetClientLanguages',
  GetMedicalDictionary = 'GetMedicalDictionary',
}

export enum MedicalDictionaryType {
  Genders = 'genders',
  DocumentKinds = 'document-kinds',
  IdentityDocuments = 'identity-documents',
  Icd10 = 'icd10',
  Positions = 'positions',
  Specialities = 'specialities',
}

export interface ModelCountry {
  Id: number;
  Name: string;
  Alpha2: CountryAlpha2;
  Alpha3: CountryAlpha3;
  TelCode: string;
  MinDigits: number;
  MaxDigits: number;
}

export interface ModelLanguage {
  Id: number;
  CodeIso6391: string | null;
  CodeIso6393: string | null;
  Name: string | null;
}

export interface ModelDictionaryItem {
  Code: string;
  Name: string;
  ParentCode: string;
}

export interface ModelDictionaryResponse {
  Items: ModelDictionaryItem[];
  Total: number;
  Page: number;
  PageSize: number;
}

export interface GetCountriesRequest {
  ActiveBranchId?: number;
}

export interface GetUsedCountriesRequest {
  ActiveBranchId?: number;
}

export interface GetUsedCitiesRequest {
  ActiveBranchId?: number;
}

export interface GetClientLanguagesRequest {
  ActiveBranchId?: number;
}

export type GetMedicalDictionaryRequest = WithActiveBranchId<{
  type: MedicalDictionaryType;
  search?: string;
  page?: number;
  pageSize?: number;
  code?: string;
}>;

export type GetCountriesResponse = ModelCountry[];
export type GetUsedCountriesResponse = ModelCountry[];
export type GetUsedCitiesResponse = string[];
export type GetClientLanguagesResponse = ModelLanguage[];
export type GetMedicalDictionaryResponse = ModelDictionaryResponse;
